export default "__VITE_ASSET__isB_9DVd__"